import React from "react";

const Testimonials = ({ data }) => {
  if (!data || !data.testimonials) {
    return null;
  }

  return (
    <section id="testimonials" className="testimonials-section section-shell">
      <div className="section-heading-row" data-reveal>
        <div>
          <p className="section-kicker">In collaboration</p>
          <h2>Known for rigorous thinking and dependable delivery.</h2>
        </div>
      </div>

      <div className="testimonial-grid">
        {data.testimonials.map((testimonial, index) => (
          <figure
            className="testimonial"
            key={testimonial.user}
            data-reveal
            style={{ "--reveal-delay": `${index * 90}ms` }}
          >
            <blockquote>{testimonial.text}</blockquote>
            <figcaption>
              <strong>{testimonial.user}</strong>
              <span>{testimonial.role}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
